// Formatação de dinheiro do Datric. 1 crédito = R$ 1, então saldo/cobrado são
// exibidos em reais. O preço por consulta pode ter até 3 casas (ex.: R$ 0,015).

export function formatBRL(value?: number | null): string {
	if (value === undefined || value === null || Number.isNaN(value)) return 'R$ 0,00';
	return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

// Preço por consulta com até 3 casas decimais (mínimo 2), ex.: R$ 0,015.
export function formatPrice(value?: number | null): string {
	if (value === undefined || value === null || Number.isNaN(value)) return 'R$ 0,00';
	return value.toLocaleString('pt-BR', {
		style: 'currency',
		currency: 'BRL',
		minimumFractionDigits: 2,
		maximumFractionDigits: 3
	});
}

// Quantas consultas o saldo ainda compra, dado o preço por consulta do usuário.
// Preço 0 (ex.: ADMIN/SUPORTE) significa consulta gratuita — retorna null, que
// a exibição traduz como "ilimitado", em vez de dividir por zero.
export function queriesFromBalance(balance?: number | null, pricePerQuery?: number | null): number | null {
	const price = Number(pricePerQuery ?? 0);
	if (!Number.isFinite(price) || price <= 0) return null;
	const value = Number(balance ?? 0);
	if (!Number.isFinite(value) || value <= 0) return 0;

	const raw = value / price;
	const nearest = Math.round(raw);
	// A divisão em ponto flutuante erra na última casa (ex.: 0,29 / 0,01 =
	// 28,999999999999996), e um Math.floor direto mostraria 28 em vez de 29.
	// Se o quociente está praticamente sobre um inteiro, é esse inteiro.
	const tolerance = Math.max(1e-9, Math.abs(raw) * 1e-12);
	return Math.abs(raw - nearest) < tolerance ? nearest : Math.floor(raw);
}

// Rótulo da quantidade de consultas ('∞' quando a consulta é gratuita).
export function formatQueries(balance?: number | null, pricePerQuery?: number | null): string {
	const qty = queriesFromBalance(balance, pricePerQuery);
	return qty === null ? '∞' : qty.toLocaleString('pt-BR');
}
